import styled, { css } from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { b as SurfaceLight } from '../Surface/index-m-jHvcs0.js';
import { E as EXITED } from '../types/react-transition-group/Transition-QJ5gMye0.js';

const Shroud = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-1rsnb3v-0"
})(["background-color:", ";position:fixed;top:0;right:auto;bottom:auto;left:0;height:100%;width:100vw;display:flex;align-items:center;justify-content:center;@media (prefers-reduced-motion:no-preference){transition:opacity 200ms ease-in-out;}opacity:0;opacity:", ";", " z-index:", ";"], ({
  theme
}) => theme.modal.overlay, ({
  $fadeState
}) => ({
  entering: 0,
  entered: 1,
  exiting: 0,
  exited: 0,
  unmounted: 0
})[$fadeState], ({
  $fadeState
}) => $fadeState === EXITED && `
  visibility: hidden;
  `, ({
  theme
}) => theme.modal.zIndex);
Shroud.displayName = 'Shroud';
const transformLeftToRight = {
  entering: 'translateX(-100%)',
  entered: 'translateX(0%)',
  exiting: 'translateX(-100%)',
  exited: 'translateX(0%)',
  unmounted: 'translateX(0%)'
};
const transformRightToLeft = {
  entering: 'translateX(100%)',
  entered: 'translateX(0%)',
  exiting: 'translateX(100%)',
  exited: 'translateX(0%)',
  unmounted: 'translateX(0%)'
};
const transformBottomToTop = {
  entering: 'translateY(100%)',
  entered: 'translateY(0%)',
  exiting: 'translateY(100%)',
  exited: 'translateY(0%)',
  unmounted: 'translateY(0%)'
};
const getSheetContentContainerStyle = (side, $slideState) => {
  switch (side) {
    case 'start':
      return css(["max-height:100%;height:100%;bottom:0;left:0;inset-inline-start:0;right:auto;inset-inline-end:auto;/*! @noflip */ transform:", ";display:flex;flex-direction:row-reverse;/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ transform:", ";right:0;inset-inline-start:0;left:auto;inset-inline-end:auto;}"], transformLeftToRight[$slideState], transformRightToLeft[$slideState]);
    case 'end':
      return css(["max-height:100%;height:100%;bottom:0;left:auto;inset-inline-start:auto;right:0;inset-inline-end:0;/*! @noflip */ transform:", ";display:flex;flex-direction:row;/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ transform:", ";right:auto;inset-inline-start:auto;left:0;inset-inline-end:0;}"], transformRightToLeft[$slideState], transformLeftToRight[$slideState]);
    case 'bottom':
    default:
      return css(["max-width:100vw;width:100vw;bottom:0;left:0;/*! @noflip */ transform:", ""], transformBottomToTop[$slideState]);
  }
};
const SheetContentContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30062554__sc-1rsnb3v-1"
})(["border-radius:0;box-sizing:border-box;word-wrap:break-word;overflow:hidden;outline:none;position:absolute;", ";@media (prefers-reduced-motion:no-preference){transition:transform 200ms ease-in-out;}"], ({
  side,
  $slideState
}) => getSheetContentContainerStyle(side, $slideState));
SheetContentContainer.displayName = 'SheetContentContainer';
const getSheetContentStyle = (side, $maxSize, padding) => {
  switch (side) {
    case 'start':
    case 'end':
      return css(["max-width:", ";height:100%;"], `calc(${$maxSize === 'viewport' ? '100vw' : '80vw'} + max(${padding},env(safe-area-inset-left)) + max(${padding},env(safe-area-inset-right)))`);
    case 'bottom':
    default:
      return css(["max-height:", ";", ""], `calc(${$maxSize === 'viewport' ? '100vh' : '65vh'} + ${padding} + max(${padding},env(safe-area-inset-bottom)))`, /* iOS workaround */$maxSize === 'viewport' ? 'max-height: -webkit-fill-available;' : '');
  }
};
const SheetContentSurface = /*#__PURE__*/styled(SurfaceLight).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1rsnb3v-2"
})(["", ";overflow-y:auto;pointer-events:auto;"], ({
  theme,
  side,
  $maxSize,
  $padding
}) => getSheetContentStyle(side, $maxSize, theme.spacing[$padding]));
SheetContentSurface.displayName = 'SheetContentSurface';
const SheetContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1rsnb3v-3"
})(["padding:", ";padding-inline-end:max(", ",env(safe-area-inset-right));padding-bottom:max(", ",env(safe-area-inset-bottom));padding-inline-start:max(", ",env(safe-area-inset-left));"], ({
  $padding,
  theme
}) => theme.spacing[$padding], ({
  $padding,
  theme
}) => theme.spacing[$padding], ({
  $padding,
  theme
}) => theme.spacing[$padding], ({
  $padding,
  theme
}) => theme.spacing[$padding]);
SheetContent.displayName = 'SheetContent';
const SheetClose = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-1rsnb3v-4"
})(["position:relative;margin-inline-start:auto;margin-inline-end:0;display:flex;"]);
const buttonBottom = /*#__PURE__*/css(["margin-block-start:5px;margin-block-end:5px;margin-inline-end:10px;margin-inline-start:auto;"]);
const buttonStart = /*#__PURE__*/css(["margin-block-start:10px;margin-block-end:auto;margin-inline-start:10px;margin-inline-end:10px;"]);
const buttonEnd = /*#__PURE__*/css(["margin-block-start:10px;margin-block-end:auto;margin-inline-end:10px;margin-inline-start:10px;"]);
const CloseButton = /*#__PURE__*/styled('button').attrs(({
  onFocus,
  onBlur
}) => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928({
      onFocus,
      onBlur
    }, focusProps),
    $focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30062554__sc-1rsnb3v-5"
})(["border:none;background:transparent;color:", ";font-size:", ";padding:", ";position:relative;", " :focus{outline:none;", "}:hover{color:", ";cursor:pointer;}"], ({
  theme
}) => theme.palette.white, ({
  theme
}) => theme.typography.size.medium, ({
  theme
}) => theme.spacing.none, ({
  side
}) => ({
  bottom: buttonBottom,
  start: buttonStart,
  end: buttonEnd
})[side], ({
  $focusVisible,
  theme
}) => $focusVisible && css(["outline:2px solid ", ";outline-offset:2px;"], theme.palette.white), ({
  theme
}) => theme.palette.white);
CloseButton.displayName = 'CloseButton';

export { CloseButton as C, SheetClose as S, Shroud as a, SheetContentContainer as b, SheetContentSurface as c, SheetContent as d };
//# sourceMappingURL=Sheet.styles-DBvJtyYA.js.map
